import { ExportColumn } from '../../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  {
    key: 'name',
    header: 'Product',
    type: 'text',
    width: 35,
  },
  {
    key: 'revenue',
    header: 'Revenue',
    type: 'money',
  },
  {
    key: 'costOfSales',
    header: 'Cost of Sales',
    type: 'money',
  },
  {
    key: 'grossMargin',
    header: 'Gross Margin',
    type: 'money',
  },
];
